import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import ShopGrid from './ShopGrid';
import ShopGridContainer from './ShopGrid.container';
import ShopGridContainerBranched from './ShopGrid.deviation_gruser.container';

export default withFeatureBranch({
  gruser_shop: ShopGridContainerBranched(ShopGrid),
})(ShopGridContainer(ShopGrid));
